import type { Transformer } from "@/Common/Models/Domain/Transformer";
import type { TherapistStripeAccountApi } from "@/Modules/Models/Api/Therapist";
import type { TherapistStripeAccount } from "@/Modules/Models/Domain/Therapist";

class StripeAccountApiToStripeAccountTransformer implements Transformer<
  TherapistStripeAccountApi,
  TherapistStripeAccount
> {
  transform(therapistStripeAccountApi: TherapistStripeAccountApi): TherapistStripeAccount {
    return {
      accountLink: therapistStripeAccountApi.account_link,
    };
  }
}

export default StripeAccountApiToStripeAccountTransformer;
